import axios from 'axios';

const validateUser = async () => {
  const { data } = await axios.get('api/users/self/validate');
  return data;
};

export default validateUser;
